import { render } from "./DeviceLinkingIntro.vue?vue&type=template&id=32bfcaf6&scoped=true&ts=true"
import script from "./DeviceLinkingIntro.vue?vue&type=script&lang=ts"
export * from "./DeviceLinkingIntro.vue?vue&type=script&lang=ts"

import "./DeviceLinkingIntro.vue?vue&type=style&index=0&id=32bfcaf6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bfcaf6"]])

export default __exports__